import AppLayout from "@/layouts/AppLayout";
import { Outlet, useLocation } from "react-router-dom";
import { PersonObjectHeading } from "@/features/person/components/PersonObjectHeading";
import TabLayout from "./_TabLayout";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { usePersonErrorHandling } from "../_components/usePersonErrorHandling";
import PersonNotFoundErrorBoundary from "../_components/PersonNotFoundErrorBoundary";

export default function CareerLayout() {
  const location = useLocation();
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const { pgaId, navLinks, shouldRenderError } = usePersonErrorHandling();

  // Routes that should bypass the app layout and instead show a focused view
  const focusedViewRoutes = [
    /\/compensation\/create\/?$/, // Compensation profile create
    /\/compensation\/[^/]+\/(view|edit)\/?$/, // Compensation profile view/edit
    /\/career-profile\/onboarding\/?$/, // Career Plan create onboarding
    /\/career-profile\/new\/?$/, // Career Plan document create
    /\/career-profile\/plans\/[^/]+\/?$/, // Career Plan document edit
    /\/career-profile\/[^/]+\/?$/, // Career Profile day focused view
    /\/career-plan\/onboarding\/?$/, // Legacy Career Plan create onboarding
    /\/career-plan\/new\/?$/, // Legacy Career Plan document create
    /\/career-plan\/plans\/[^/]+\/?$/, // Legacy Career Plan document edit
    /\/career-plan\/[^/]+\/?$/ // Legacy Career Plan day focused view
  ];

  // Check if current route should use focused view
  const isFocusedView = focusedViewRoutes.some((route) => route.test(location.pathname));

  // If this is a focused view page, render it directly without the app layout
  if (isFocusedView) {
    return <Outlet />;
  }

  // Early return for error cases
  if (shouldRenderError) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <PersonNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile && (
        <Breadcrumb compactOnly compactTitle="Career" backLink={{ to: "/people/:pgaId", params: { pgaId: pgaId! } }} />
      )}
      <PersonObjectHeading pgaId={pgaId!} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </AppLayout>
  );
}
